export const en = {
    "error-not-loaded": "You haven't uploaded anything yet",
    "image-table-copy": "Copy",
    "image-table-delete": "Delete",
    "image-table-error": "An error has occurred",
    "image-table-error-big-size": "File size exceeded",
    "image-table-error-incorrect-image": "Incorrect image",
    "image-table-error-limit": "The quota for images has been exceeded",
    "image-table-error-low-size": "The file size is less than the allowed one",
    "image-table-error-wrong-size": "Invalid file size",
    "info-sounds": "Sounds longer than 2 minutes will be cut to the maximum length.",
    "info-to-upload": "To upload files, move them to the area or click on it.",
    "menu-images": "Images",
    "menu-sounds": "Sounds"
} as const;
export const ru = {
    "error-not-loaded": "Вы еще ничего не загрузили",
    "image-table-copy": "Скопировать",
    "image-table-delete": "Удалить",
    "image-table-error": "Произошла ошибка",
    "image-table-error-big-size": "Превышен размер файла",
    "image-table-error-incorrect-image": "Некорректное изображение",
    "image-table-error-limit": "Превышена квота на изображения",
    "image-table-error-low-size": "Размер файла меньше допустимого",
    "image-table-error-wrong-size": "Недопустимый размер файла",
    "info-sounds": "Звуки длиной более 2 минут будут обрезаны до максимальной длины.",
    "info-to-upload": "Для загрузки файлов переместите их в область или нажмите на нее.",
    "menu-images": "Изображения",
    "menu-sounds": "Звуки"
} as const;